module.exports = __webpack_public_path__ + "img/volvo_user.31e515f9.svg";